import React, {useState, useRef} from 'react';
import {Toast} from "primereact/toast";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {isNullOrUndef} from "chart.js/helpers";
import moment from "moment";
import {InvoicesService} from "../../service/InvoicesService";
import {Calendar} from "primereact/calendar";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";

export const IssuedEnteredInvoices = (props) => {

    const [managerList, setManagerList] = useState([])
    const [summary, setSummary] = useState(null)
    const [loading, setLoading] = useState(false);
    const [dateFromTo, setDateFromTo] = useState([]);
    const invoicesService = new InvoicesService();
    const toast = useRef(null);
    const dt = useRef(null);

    const invoiceTypes = [
        {id: null, name: ''},
        {id: 'DEBIT', name: 'Debit'},
        {id: 'CREDIT', name: 'Credit'},
    ]

    const getIssuedEnteredInvoices = (exportToExcel) => {
        setLoading(true)
        const [start, end] = dateFromTo || [];

        const isValidDate = (d) => d instanceof Date && !isNaN(d);

        if (!isValidDate(start) || !isValidDate(end)) {
            toast.current.show({
                severity: 'warn',
                summary: 'Date Range',
                detail: 'Please select a valid Date from to',
                life: 3000
            });
            setLoading(false);
            return;
        }

        const dateFrom = moment(start).format('YYYY-MM-DD');
        const dateTo = moment(end).format('YYYY-MM-DD');
        if (exportToExcel) {
            exportIssuedEnteredInvoicesToExcel(dateFrom, dateTo)
        } else {
            getIssuedEnteredInvoicesWithParams(dateFrom, dateTo)
        }
    }

    const exportIssuedEnteredInvoicesToExcel = (dateFrom, dateTo) => {
        invoicesService.exportToExcelIssuedEnteredInvoices(dateFrom, dateTo)
            .then(r => {
                if (r.status === 200) {
                    const url = window.URL.createObjectURL(new Blob([r.data],
                        {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}));
                    const link = document.createElement('a')
                    link.href = url;
                    link.setAttribute('download', 'IssuedEnteredInvoices_' + moment(new Date()).format('YYYY-MM-DD_hh:mm:ss') + '.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                setLoading(false)
            })
    }

    const getIssuedEnteredInvoicesWithParams = (dateFrom, dateTo) => {
        invoicesService.getIssuedEnteredInvoices(dateFrom, dateTo)
            .then(r => {
                if(!isNullOrUndef(r) && !isNullOrUndef(r.data) && r.data.length > 0) {
                    const dataWithTotal = r.data.map(item => ({
                        ...item,
                        total: item.creditCount + item.debitCount
                    }));
                    setManagerList(dataWithTotal);
                    setSummary(r.summary);
                }
                setLoading(false);
            });
    }

    const header = <>
        <div className="table-header">
            <h5 className="p-mb-2">Issued / entered invoices</h5>
        </div>
        <div className="flex justify-content-between flex-wrap card-container">
            <div className="flex align-items-center justify-content-center">
                    <span className="p-float-label ">
                        <Calendar id={'filter-dateFromTo'} selectionMode="range"
                                  numberOfMonths={3} dateFormat={'yy-mm-dd'} locale={'lt'} showButtonBar
                                  value={dateFromTo} onChange={e => setDateFromTo(e.value)}/>
                        <label htmlFor={'filter-dateFromTo'}>{'Date From To'}</label>
                    </span>
                {/*<span className="p-float-label">*/}
                {/*    <Dropdown id={'filter-invoiceType'} options={invoiceTypes}*/}
                {/*              value={invoiceType}*/}
                {/*              onChange={(e) => setInvoiceType(e.target.value)}*/}
                {/*              optionLabel={'name'} optionValue={'id'} dropdownIcon={null}/>*/}
                {/*    <label htmlFor={'filter-invoiceType'}>Debit/Credit</label>*/}
                {/*</span>*/}
                <span className={'p-buttonset p-ml-3'}>
                            <Button icon="pi pi-search" iconPos="right"
                                    onClick={() => getIssuedEnteredInvoices(false)}/>
                            <Button icon="pi pi-times" iconPos="right" onClick={() => {
                                setManagerList([])
                                setSummary(null)
                                setDateFromTo([])
                            }}/>
                        </span>
            </div>
            <div>
                <div className="flex align-items-center justify-content-center">
                    <Button icon="pi pi-file-excel" iconPos="right" label={'Export'}
                            onClick={() => getIssuedEnteredInvoices(true)}/>
                </div>
            </div>
        </div>
    </>;

    const managerTemplate = (manager) => {
        if (!isNullOrUndef(manager)) {
            return manager.firstName + ' ' + manager.lastName
        } else {
            return ''
        }
    }

    const footerGroup = () => {
        return <ColumnGroup>
            <Row>
                <Column footer={'TOTAL'} style={{fontWeight: 'bold'}}/>
                <Column footer={!isNullOrUndef(summary) ? summary.debit : '-'} style={{fontWeight: 'bold'}}/>
                <Column footer={!isNullOrUndef(summary) ? summary.credit : '-'} style={{fontWeight: 'bold'}}/>
                <Column footer={!isNullOrUndef(summary) ? summary.total : '-'} style={{fontWeight: 'bold'}}/>
            </Row>
        </ColumnGroup>
    }

    return (
        <div className="p-grid" style={{margin: '0 -20px'}}>
            <div className="p-col-12">
                <Toast ref={toast}/>
                <div style={{height: 'calc(100vh - 115px)', fontSize: '15px'}}>
                    <DataTable ref={dt} value={managerList}
                               size="small"
                               dataKey="id"
                               footerColumnGroup={footerGroup()}
                               scrollable rows={managerList.length}
                               responsiveLayout="scroll"
                               scrollHeight="flex" id={'issuedEnteredInvoices-list'}
                               stateKey="issued-entered-invoices-dt-state-local"
                               className="datatable-responsive" loading={loading} rowHover
                               emptyMessage="No entry found." header={header}>
                        <Column sortable={true} field={'firstName'} header={'Manager'}
                                body={rowData => managerTemplate(rowData)}/>
                        <Column sortable={true} field={'debitCount'} header={'Debit'}/>
                        <Column sortable={true} field={'creditCount'} header={'Credit'}/>
                        <Column sortable={true} field={'total'} header={'Total'}/>
                    </DataTable>
                </div>
            </div>
        </div>
    );

}